/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [error-handling.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 10.01.20, 11:27
 */

import axios from 'axios';
import {environment as env} from "../environment";
import {getBearer, refreshConfig, saveBearer} from "../local-storage";
import {logoutRequest} from "../index";

export const FLAG_ERROR = 'FLAG_ERROR';
export const RESET_ERROR = 'ACK_ERROR';
export const TOKEN_EXPIRED = 11;

window._isOnline_ = window.navigator.onLine;
window._isServerAlive_ = true;

export function asyncHandleError(error, retry) {

    return dispatch => {
        checkIsServerAlive(error);

        if(isServerAlive() && error && error.response && error.response.data) {
            const {data} = error.response;
            if(data.errorCode === TOKEN_EXPIRED) {
                dispatch(asyncRefreshToken(retry));
            } else {
                if(data.status >= 300 && data.status <= 400) {
                    dispatch(flagError(data));
                }
                if(data.status === 401) {
                     // authorization will be handled somewhere else..

                } else if(data.status === 404) {
                    redirectToPage('/page-not-found', data);
                } else {
                    redirectToPage('/error-page', data);
                }
            }
        } else {
            redirectToErrorPage(error);
        }
    }
}

/* only in auth mode */
function asyncRefreshToken(retry) {
    return dispatch => {
        axios.get(`${env.ROOT_SERVER_URL}/public/token`, refreshConfig())
        .then(response => {
            console.log('REFRESH OK', response);
            // const bearer = JSON.parse(localStorage.getItem('bearer'));
            // const refresh = {...bearer, 'token': response.data.token};
            // localStorage.setItem('bearer', JSON.stringify(refresh));

            saveBearer({...getBearer(), 'token': response.data.token});
            retry && retry();
        })
        .catch(error => {
            console.log('SECURITY ERROR', error.toJSON());
            dispatch(logoutRequest());
        });
    };
}

// follow-up check for server health - origination error would be something else
export function checkIsServerAlive(error) {
    console.log('Originating error checkIsServerAlive', error)

    try {
        axios.get(`${env.ROOT_SERVER_URL}/public/healthcheck`)
        .then (response => {
            console.log('Healthcheck', response);
            isServerAlive(true);
        })
        .catch(error => {
            console.log('Healthcheck failed', error);
            isServerAlive(false);
        })
    } catch (error) {
        console.log('Healthcheck call failed', error);
        isServerAlive(false);
    }

    return isServerAlive();
}

// hints that app is not connected to the internet - currently set by the browser itself
export const isOnline = (online) => {
    if (online !== undefined) {
        window._isServerAlive_ = online;
    }
    return window._isOnline_;
}

// hints that server is not up and running - set if a server call fails with 'Network Error'
export const isServerAlive = (alive) => {
    if (alive !== undefined) {
        window._isServerAlive_ = alive;
    }
    return window._isServerAlive_;
}

/* flag last error to interested components (will overwrite older errors) */
export const flagError = (data) => ({type: FLAG_ERROR, data});
export const resetError = (value = false) => ({type: RESET_ERROR, value});

/**
 * potentially dangerous call since the refresh can cause a browser re-render loop
 * @Deprecated
 */
export const gotoPageAndRefresh = (page, data) => {
    window.location.href = `${page}/?status=${data.status}&error=${data.error}&message=${data.message}`;
};

export const redirectToPage = (page, data) => {
    window.location.replace(`${page}/?status=${data.status}&error=${data.error}&message=${data.message}`);
};

export const redirectToErrorPage = (error) => {
    console.log(error.toJSON())
    return redirectToPage('/error-page',
        {status: 400, error: 'System error', message: 'A fatal system error occurred'});
};
